/**
 * external dependencies
 */
import { TabulatorFull } from 'tabulator-tables';

/**
 * internal dependencies
 */
import { TRANSACTION_FITLER } from '../../../types/types';
import { filterClear, terminalDropDown } from './table-filter-helper';
import { setDateFilter } from '../tableHelpers/comman-helpers';

import GetHeartBeat from '../../../routes/get-heartbeat';

/**
 * Function that handles the table filter for the transactions table.
 * 
 * @param {TabulatorFull} tableObject the table class instance
 * 
 * @returns void
 */
export const heartBeatTableFilter = (tableObject: TabulatorFull) => {
  if ( typeof tableObject != 'object' || tableObject === null || tableObject === undefined ) return;

  TRANSACTION_FITLER.searchFilterButton.addEventListener('click', () => {
    TRANSACTION_FITLER.searchFilterButton.classList.add('aafp_button-loading');
    searchHeartbeatTable(tableObject);
  });

  TRANSACTION_FITLER.clearFilterButton.addEventListener('click', async () => {
    TRANSACTION_FITLER.clearFilterButton.classList.add('aafp_button-loading');

    let startDate = setDateFilter(TRANSACTION_FITLER.dateToSetTwo);
    let endDate = new Date(new Date().setUTCHours(23, 59, 59, 0));

    filterClear('.table-filter-clear');

    TRANSACTION_FITLER.startDate.valueAsDate = startDate;
    TRANSACTION_FITLER.endDate.valueAsDate = endDate;

    const data = await GetHeartBeat( startDate, endDate, '');

    tableObject.replaceData(data.body);
    tableObject.clearFilter(true);
    TRANSACTION_FITLER.clearFilterButton.classList.remove('aafp_button-loading');
  });
}

/**
 * Get data from input fields and sets a filter on the table object. This function cannot be put into
 * the table-helpers file due to different amount of fields that can be used as a filter.
 * 
 * @param {TabulatorFull} table the table class instance. 
 * 
 * @returns void
 */
const searchHeartbeatTable = async (table: TabulatorFull) => {
  let startDate = document.querySelector('#search-date-start') as HTMLInputElement;
  let endDate = document.querySelector('#search-date-end') as HTMLInputElement;  
  let terminal = document.querySelector('#aafp_terminal-list-sort') as HTMLInputElement;

  let stDate = new Date(new Date(startDate.value).setUTCHours(0, 0, 0, 0));
  let eDate = new Date(new Date(endDate.value).setUTCHours(23, 59, 59, 0));
  let terminalId = terminal.value.toUpperCase();

  const data = await GetHeartBeat( stDate, eDate, terminalId);

  table.replaceData(data.body);
  TRANSACTION_FITLER.searchFilterButton.classList.remove('aafp_button-loading');
}